import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthSessionService } from './auth-session.service';

@Injectable()
export class AuthExpiryInterceptor implements HttpInterceptor {
  constructor(private authSession: AuthSessionService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const usesLoginToken = request.headers.get('Authorization')?.startsWith('Bearer ') === true;

    return next.handle(request).pipe(
      catchError((error: unknown) => {
        if (usesLoginToken && error instanceof HttpErrorResponse && error.status === 401) {
          this.authSession.logoutExpiredSession();
        }
        return throwError(() => error);
      })
    );
  }
}
